module.exports = __webpack_public_path__ + "static/media/m-cover-otc.9784777d.png";